module.exports = __webpack_public_path__ + "static/media/help_center.2bb3f063.svg";